















import { Component, Vue, Prop, Provide, Emit } from 'vue-property-decorator'
import { AButton } from '@/components'

@Component({
  components: { AButton }
})
export default class NoResult extends Vue {
  @Prop({
    default() {
      return true
    }
  })
  action!: boolean
  // @Emit()
  public reset() {
    window.location.reload()
  }
}
